<!-- eslint-disable max-len -->
<template>
  <div
    class="info-page page"
  >
    <div class="info-view">
      <div class="info-title">
        基本信息
      </div>
      <div
        class="split-line-w"
      />
      <div class="info-content">
        <ul class="form-readonly">
          <li class="flx-row-str">
            <span class="label">建筑面积</span>
            <span class="value">{{ projectInfo.coveredArea }}</span>
          </li>
          <li class="flx-row-str">
            <span class="label">占地面积</span>
            <span class="value">{{ projectInfo.area }}</span>
          </li>
          <li class="flx-row-str">
            <span class="label">产权年限</span>
            <span class="value">{{ projectInfo.year }}年</span>
          </li>
          <li class="flx-row-str">
            <span class="label">开发商品牌</span>
            <span class="value">{{ projectInfo.brand }}</span>
          </li>
          <li class="flx-row-str">
            <span class="label">项目坐标</span>
            <span class="value">{{ projectInfo.addr }}</span>
          </li>
          <li class="flx-rowstr">
            <span class="label">项目简介</span>
            <span class="value">
              <div>信义控股集团作为城市化进程的推动者与区域运营商，深耕项目所在区域更超20余载，与区域相互成就，成功打造信义金御半山系列等品质与形象标杆，为众多尊贵业主打造理想生活社区。如今信义金御半山系列再上新作——信义金御半山•珑门，再度聚焦全城目光。</div>
              <div>项目位于惠康路与锦龙路交汇处，距离5号线与17号线（规划中）换乘站百鸽笼地铁站直线距离约358m，可1站抵达布吉站后换乘至3/14号线（1站罗湖北站、3站岗厦北站）。周边城市面貌焕新，“三山五园”环绕，配套资源丰富——环绕以华润万象汇、信义礼信汇、沃尔玛生活广场等为代表的繁华商业，以百合外国语、贤义外国语、百外世纪小学、春蕾小学、信义实验小学等为代表的全龄教育。</div>
              <div>项目分两期开发，一期总占地2.3万方，总建面约17.3万方；主力产品约86-122㎡3-4房住宅，标准层2梯4户，户型方正实用，采光通透，更有约99~100㎡真4房稀缺户型。整体采用“一轴一中心、两环四花园”的围合式布局设计，做内向型景观空间。高颜值藏青与银白色外立面呼应城市美学，主入口景观台地与水景喷泉体现尊贵入户仪式感，中心阳光泳池与生活剧场延伸生活空间。</div>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="info-view">
      <div class="info-title">
        小区详情
      </div>
      <div
        class="split-line-w"
      />
      <div class="info-content">
        <ul class="form-readonly">
          <li class="flx-row-str">
            <span class="label">梯户比</span>
            <span class="value">2梯4户低梯户比</span>
          </li>
          <li class="flx-row-str">
            <span class="label">规定容积率</span>
            <span class="value">5.19</span>
          </li>
          <li class="flx-row-str">
            <span class="label">绿化覆盖率</span>
            <span class="value">40.03%</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      projectInfo: {
        name: '信义金御半山·珑门',
        tagInfo: ['信义控股'],
        area: '约23002㎡',
        coveredArea: '约175495㎡',
        brand: '信义控股',
        year: 70,
        addr: '深圳都市核心区·5号线百鸽笼站',
        detail: '',
      },
    };
  },
  created() {
  },
  methods: {
  },
};
</script>

<style lang="less" scope>
.info-page {
  position: relative;
  background-color: #f0f0f0;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .info-view {
    font-size: 14px;
    padding: 15px;
    background-color: #ffffff;
    margin-bottom: 15px;
  }
  .split-line-w {
    margin: 8px 0;
  }
}
/* 表单相关 */
.form-readonly {
  li {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 4px 0;
    .label {
      flex-shrink: 0;
      color: rgba(0, 0, 0, .6);
      font-size: 13px;
      width: 2rem;
      text-align: right;
    }
    .value {
      flex-shrink: 0;
      font-size: 13px;
      margin-left: 12px;
      div {
        max-width: 6.8rem;
        word-wrap: break-all;
        white-space: normal;
      }
    }
  }
}
</style>
